export const EXPORT_SIZE_LIMIT = import.meta.env.EXPORT_SIZE_LIMIT || 10000;
